import { LOGO_BARS, LOGO_COLORS, LOGO_P, MARK_BAR_X, MARK_VIEWBOX } from './predicoLogo';

// The Predico mark: the wordmark's "p" with the logo's orange bar over it.
// Used where the full wordmark does not fit (phone app bar); the collapsed
// desktop sidebar folds its wordmark into the same mark (SidebarLogo).
export default function PredicoMark({ className = '' }) {
  const { orange } = LOGO_BARS;
  return (
    <svg viewBox={MARK_VIEWBOX} className={className} aria-hidden="true">
      {/* Logo ink in light mode, white (like the dark wordmark) in dark mode. */}
      <path d={LOGO_P} fill={LOGO_COLORS.ink} fillRule="evenodd" className="dark:fill-white" />
      <rect x={MARK_BAR_X} y={orange.y} width={orange.width} height={orange.height} fill={LOGO_COLORS.orange} />
    </svg>
  );
}
